import { z } from 'zod';
const SessionIdInboundSchema = z
    .object({
    sessionUuid: z.string().optional()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'session_id',
    ...rest
}));
export const SESSION_ID_PAYLOAD_DEFINITION = {
    zodSchema: SessionIdInboundSchema
};
